export const unique = <T>(arr: T[]): T[] => Array.from(new Set(arr));
